import dynamic from 'next/dynamic';
import {ErrorBoundary} from 'react-error-boundary';
import type {QupNudges} from '@jobseeker/common-core/services/qup.service';

const LinkedInSyncNudgeWidget = dynamic(
  () =>
    import('@jobseeker/feature-profile/widget').then(
      mod => mod.LinkedInSyncNudgeWidget
    ),
  {ssr: false}
);

export interface LinkedInSyncNudgeHarnessProps {
  nudges?: QupNudges | null;
  manualOpen?: boolean;
  onManualClose?: () => void;
}

const LinkedInSyncNudgeHarness = (props: LinkedInSyncNudgeHarnessProps) => (
  <ErrorBoundary FallbackComponent={() => null}>
    <LinkedInSyncNudgeWidget {...props} />
  </ErrorBoundary>
);

export default LinkedInSyncNudgeHarness;
